/**
 * @description Remove escaped words from a string
 *
 * @param {string} value The value to strip escaped words from
 * @returns {string} the value without escaped words
 */
export var stripEscapedWords = function (value) { return value
    .replace(/((\s|^)\\[^\s$]+(\s|$))/, ' ')
    .replace('  ', '')
    .trim(); };
//# sourceMappingURL=stripEscapedWords.js.map